import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=00bee6cc&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=00bee6cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bee6cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00bee6cc')) {
      api.createRecord('00bee6cc', component.options)
    } else {
      api.reload('00bee6cc', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=00bee6cc&scoped=true&", function () {
      api.rerender('00bee6cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26jogBczsfJJH/JS/comp/CookieBox.vue"
export default component.exports